export default {
      id: "logo-small-purple-usage",
      viewBox: "0 0 68 67",
      url: "/" + "sprite.svg#logo-small-purple",
      toString: function () {
        return this.url;
      }
    }